import { Component, input } from '@angular/core';

@Component({
	selector: 'eye-slash-icon',
	templateUrl: './eye-slash-icon.html',
	standalone: true
})
export class EyeSlashIconComponent {
	color = input<string>('#000000');
	size = input<number>(20);
}

